import React from "react";
import { Layout } from "../components/Layout";
import { useDiscoverImages } from "../hooks/useDiscoverImages";
import VirtualTryOn from "../components/VirtualTryOn";
import { useLocation } from "react-router-dom";
import type { DiscoverImage } from "../hooks/useDiscoverImages";
import { PaperSection } from "../components/PaperSection";
import type { UserUpload } from "../hooks/useUserUploads";
import FeedbackWidget from "../components/FeedbackWidget";

interface LocationState {
	selectedImage?: DiscoverImage;
	selectedPhoto?: UserUpload;
	fromDiscover?: boolean;
}

export default function TryOn() {
	const { images, loading, error } = useDiscoverImages();
	const location = useLocation();
	const state = location.state as LocationState;

	return (
		<Layout>
			<div className="space-y-4 sm:space-y-6 px-4 sm:px-0">
				<div>
					<h1 className="text-2xl sm:text-3xl font-display page-title">
						Virtual Try-On
					</h1>
					<p className="text-gray-600 mt-1 text-sm sm:text-base">
						Try on looks from our discover section using your own photos.
					</p>
				</div>

				{error ? (
					<PaperSection variant="super-heavy" className="text-red-600 border-l-4 border-red-400">
						<p>Error: {error}</p>
					</PaperSection>
				) : loading ? (
					<div className="flex justify-center items-center py-10">
						<div className="spinner"></div>
					</div>
				) : (
					<VirtualTryOn
						discoverImages={images}
						initialSelectedImage={state?.selectedImage}
						initialSelectedPhoto={state?.selectedPhoto}
						fromDiscover={state?.fromDiscover}
					/>
				)}
			</div>
			<FeedbackWidget />
		</Layout>
	);
}
